function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { removeItem } from 'motion-utils';
import { microtask } from '../frameloop/microtask.mjs';
import { startViewAnimation } from './start.mjs';
var builders = [];
var current = null;

function next() {
  current = null;

  var _builders = builders,
      _builders2 = _slicedToArray(_builders, 1),
      nextBuilder = _builders2[0];

  if (nextBuilder) start(nextBuilder);
}

function start(builder) {
  removeItem(builders, builder);
  current = builder;
  startViewAnimation(builder).then(function (animation) {
    builder.notifyReady(animation);
    animation.finished.finally(next);
  });
}

function processQueue() {
  var _builders$;

  /**
   * Iterate backwards over the builders array. We can ignore the
   * "wait" animations. If we have an interrupting animation in the
   * queue then we need to batch all preceeding animations into it.
   * Currently this only batches the update functions but will also
   * need to batch the targets.
   */
  for (var i = builders.length - 1; i >= 0; i--) {
    var builder = builders[i];
    var interrupt = builder.options.interrupt;

    if (interrupt === "immediate") {
      var _ret = function () {
        var batchedUpdates = builders.slice(0, i + 1).map(function (b) {
          return b.update;
        });
        var remaining = builders.slice(i + 1);

        builder.update = function () {
          batchedUpdates.forEach(function (update) {
            return update();
          });
        }; // Put the current builder at the front, followed by any "wait" builders


        builders = [builder].concat(_toConsumableArray(remaining));
        return "break";
      }();

      if (_ret === "break") break;
    }
  }

  if (!current || ((_builders$ = builders[0]) === null || _builders$ === void 0 ? void 0 : _builders$.options.interrupt) === "immediate") {
    next();
  }
}

function addToQueue(builder) {
  builders.push(builder);
  microtask.render(processQueue);
}

export { addToQueue };